import React, { useState, useContext } from "react";
import { CartProducts } from "../../modals/Cart";
import Form from "react-bootstrap/Form";
import { addToCartMessages as msg } from "../../utils/constants";
import { UpdateCartService, ViewCartService } from "../../services/services";
import AppContext from "../../context/AppContext";

interface Props extends CartProducts {
  setIsSyncing: (val: boolean) => void;
}

const UpdatableField: React.FC<Props> = (item) => {
  const [value, setValue] = useState<string>(String(item.quantity));
  const [lastSavedValue, setLastSavedValue] = useState<number>(item.quantity);
  const { setCart, setCartTotals, tokenExpired } = useContext(AppContext);

  const UpdateCart = (val: number) => {
    item.setIsSyncing(true);
    UpdateCartService(item.id, item.product_id, val)
      .then(() => {
        return ViewCartService();
      })
      .then((result) => {
        if (result.data.flag) {
          setCart(result.data.data);
          setCartTotals(result.data.total_summary);
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          tokenExpired();
        }
      })
      .finally(() => {
        item.setIsSyncing(false);
      });
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const raw = e.target.value;

    // Allow empty string so the user can clear and retype
    if (raw === "") {
      setValue("");
      return;
    }

    // Only allow positive integers (no decimals, no 'e')
    if (/^\d+$/.test(raw)) {
      setValue(raw);
    }
  };

  const handleBlur = () => {
    let numericValue = parseInt(value, 10);

    // If empty or invalid, revert to the last saved value
    if (isNaN(numericValue) || numericValue < msg.MIN_QTY) {
      numericValue = lastSavedValue;
      setValue(String(numericValue));
      return; // No API call needed since we're reverting
    }

    setValue(String(numericValue));

    // Only call API if the value actually changed
    if (numericValue !== lastSavedValue) {
      setLastSavedValue(numericValue);
      UpdateCart(numericValue);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent 'e', '+', '-', '.' in the input
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }

    // Submit on Enter
    if (e.key === "Enter") {
      (e.target as HTMLInputElement).blur();
    }
  };

  return (
    <div className="number-input">
      <Form.Group className="form-group">
        <Form.Control
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          className="form-control qty-input"
          value={value}
          onChange={(e) => handleChange(e)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          style={{ width: "80px", textAlign: "center" }}
        />
      </Form.Group>
    </div>
  );
};

export default UpdatableField;
